const en = {
	// General
	"app.title": "Numerys",
	"app.description": "Track your expenses and revenues easily",
	"global.appLoading": "Loading...",

	// Login page
	"login.email": "Email",
	"login.password": "Password",
	"login.emailPlaceholder": "Enter your email",
	"login.passwordPlaceholder": "Enter your password",
	"login.submit": "Log in",
	"login.loading": "Logging in...",
	"login.forgotPassword": "Forgot password",
	"login.noAccount": "Don't have an account yet?",
	"login.signupLink": "Register now",
	"login.error.invalidCredential":
		"Invalid credentials. Please check your email and password.",
	"login.error.generic": "Error during login.",
	"login.error.emailRequired": "Please enter your email.",
	"login.error.resetPassword": "Error sending the reset password email.",

	// Register page
	"register.submit": "Create an account",
	"register.haveAccount": "Already have an account?",
	"register.loginLink": "Log in",
	"register.accept": "I have read and accept the",
	"register.terms": "Terms of Use",
	"register.loading": "Registering...",
	"register.error.emailInUse": "This email address is already in use.",
	"register.error.invalidEmail": "Invalid email address.",
	"register.error.weakPassword": "Password too weak (minimum 6 characters).",
	"register.error.generic": "Error during registration.",
	"register.error.emailNotWhitelisted":
		"Your email address is not authorized. Please contact the administrator.",
	"register.error.mustAcceptTerms":
		"You must accept the Terms of Use to register.",

	// Navigation
	"nav.login": "Login",
	"nav.register": "Register",
	"nav.home": "Dashboard",
	"nav.history": "History",
	"nav.analysis": "Analysis",
	"nav.add": "Add",
	"nav.settings": "Settings",

	// Home page
	"home.title": "Dashboard",
	"home.loading": "Loading home statistics...",
	"home.empty.title": "No data available",
	"home.empty.description":
		"Start by adding your first transactions to see your statistics.",
	"home.totalAllTime": "All",
	"home.total": "Total",
	"home.totalSpent": "Total spent",
	"home.totalWithoutHousing": "Total without housing",
	"home.totalIncome": "Total income",
	"home.balance": "Balance",
	"home.noTransactions": "No transactions available.",
	"home.ofExpenses": "of expenses",
	"home.ofIncome": "of income",

	// History page
	"history.title": "Transaction history",
	"history.loading": "Loading transactions...",
	"history.empty.title": "No transactions recorded yet",
	"history.empty.description":
		"You haven't added any transactions yet. Create one from the add transaction form.",
	"history.loadData.title": "Ready to load your transactions",
	"history.loadData.description":
		"Click below to load your transaction history",
	"history.loadData.button": "Load Data",
	"history.loadMore": "Load more",
	"history.groupModeToggle": "Toggle group mode",
	"history.groupByDay": "Group by date",
	"history.groupByCategory": "Group by category",
	"history.view": "Details",
	"history.confirmDelete": "Delete transaction",
	"history.search.placeholder": "Search by title, date, amount...",
	"history.search.noResults.title": "No results",
	"history.search.noResults.description":
		"No transaction matches '{{searchQuery}}'",

	// Analysis page
	"analysis.title": "Analysis",
	"analysis.loading": "Loading statistics...",
	"analysis.empty.title": "No data available",
	"analysis.empty.description":
		"No transaction data is available. Add transactions to see your analysis.",
	"analysis.noChartsData.title": "No charts to display",
	"analysis.noChartsData.description":
		"The selected filters don't match any data for this year.",
	"analysis.average": "Avg",
	"analysis.monthlyExpensesByCategory": "Monthly expenses by category",
	"analysis.selectYear": "Year",
	"analysis.selectCategories": "Categories",
	"analysis.expenseBreakdown": "Expense breakdown",
	"analysis.monthlyOverview": "Monthly overview",
	"analysis.income": "Income:",
	"analysis.expenses": "Expenses:",
	"analysis.expenseTotal": "Expenses",
	"analysis.balance": "Balance",
	"analysis.monthlyIncome": "Monthly income",
	"analysis.incomeBySubcategory": "Income breakdown",
	"analysis.yearlyEvolutionByCategory":
		"Yearly expenses' evolution by category",
	"analysis.legend.actual": "Actual data",
	"analysis.legend.projected": "Annual projection",
	"analysis.tooltip.basedOnMonths": "Projection based on {{count}} months",
	"analysis.monthlyBalance": "Monthly change in balance",
	"analysis.yearlyBalance": "Yearly change in balance",

	// Add transaction page
	"add.title": "Add a transaction",

	// Settings page
	"settings.title": "Settings",
	"settings.loading": "Loading settings...",
	"settings.theme": "Theme",
	"settings.useSystemTheme": "Use system theme",
	"settings.light": "Enable dark mode",
	"settings.dark": "Disable dark mode",
	"settings.design": "Design",
	"settings.bottomNavStyle": "Select navigation bar style",
	"settings.fixed": "Fixed",
	"settings.floating": "Floating",
	"settings.full": "Full",
	"settings.designStyle": "Select app style",
	"settings.ios18Style": "iOS 18",
	"settings.ios26Style": "iOS 26",
	"settings.language": "Language",
	"settings.selectLanguage": "Select language",
	"settings.account": "My account",
	"settings.email": "Email",
	"settings.emailNotConfirmed": "not verified",
	"settings.emailConfirmed": "verified",
	"settings.resetPassword": "Reset my password",
	"settings.changeEmail": "Change my email address",
	"settings.enterNewEmail": "Enter your new email address",
	"settings.export": "Export my data",
	"settings.exporting": "Exporting data...",
	"settings.exportLoading": "Exporting all your personal data...",
	"settings.logout": "Log out",
	"settings.deleteAccount": "Delete my account",
	"settings.deleteAccountButton": "Delete account",
	"settings.deletingAccount": "Deleting account...",
	"settings.accountDeleted":
		"Your account and all your data have been successfully deleted.",
	"settings.enterPasswordToConfirm": "Please enter your password to confirm.",
	"settings.legalInfo": "Legal information",
	"settings.accessAdmin": "Access admin space",

	// Admin page
	"admin.title": "Admin",
	"admin.loading": "Loading admin page...",
	"admin.manageWhitelist": "Manage whitelist",
	"admin.addToWhitelist": "Add",
	"admin.removeFromWhitelist": "Delete from whitelist",
	"admin.delete": "Delete",
	"admin.confirmDeleteWhitelist":
		"Do you really want to remove the address '{{email}}' from the whitelist?",
	"admin.emailRemoved": "Email address removed from whitelist.",
	"admin.manageUsers": "Manage users",
	"admin.email": "Email",
	"admin.emailVerified": "Email verified",
	"admin.changeRole": "Role",
	"admin.roleUpdated": "User role updated successfully.",
	"admin.roleUpdateError": "Error while updating user role",
	"admin.emailRequired": "Email address required.",
	"admin.emailAdded": "Email address added to whitelist.",
	"admin.emailAddError": "Error while adding email to whitelist.",
	"admin.emailRemoveError": "Error removing from whitelist.",
	"admin.updatingRole": "Updating role...",
	"admin.seeMore": "See more",
	"admin.seeLess": "See less",
	"admin.recurringTransactions": "Recurring transactions",
	"admin.recurringDescription":
		"Manually process recurring transactions for the next 48 hours",
	"admin.processRecurring": "Process now",
	"admin.processingRecurring": "Processing recurring transactions...",
	"admin.recurringProcessed":
		"{{processed}} transactions processed, {{skipped}} skipped (paused), {{failed}} failed",
	"admin.recurringProcessError":
		"Error while processing recurring transactions: ",
	"admin.emailPlaceholder": "user@example.com",
	"admin.yes": "✅",
	"admin.no": "❌",
	"admin.roleUser": "User",
	"admin.roleAdmin": "Admin",

	// Reauth Form
	"reauth.title": "Re-authentication Required",
	"reauth.description":
		"For security reasons, please confirm your password to continue.",
	"reauth.placeholder": "Your password",

	// Add transaction form
	"form.expense": "Expense",
	"form.income": "Income",
	"form.title": "Title",
	"form.titlePlaceholder": "e.g. Drinks",
	"form.amount": "Amount",
	"form.amountPlaceholder": "€12.50",
	"form.date": "Date",
	"form.nextOccurrence": "Next occurrence",
	"form.invalidDate": "Invalid date",
	"form.category": "Category",
	"form.subCategory": "Subcategory",
	"form.selectSubCat": "-- Select --",
	"form.noSubCatConfig": "No subcategory configured for this category.",
	"form.noSubCategory": "No subcategory",
	"form.actions": "Actions",
	"form.delete": "Delete",
	"form.add": "Add a transaction",
	// Recurring transaction form
	"form.recurring.enable": "Recurring transaction",
	"form.recurring.frequency": "Frequency",
	"form.recurring.interval": "Interval",
	"form.recurring.increment": "Increase interval",
	"form.recurring.decrement": "Decrease interval",
	"form.recurringFrequency.days": "Daily",
	"form.recurringFrequency.weeks": "Weekly",
	"form.recurringFrequency.months": "Monthly",
	"form.recurringFrequency.years": "Yearly",
	"form.recurring.days": "day",
	"form.recurring.days_plural": "{{count}} days",
	"form.recurring.weeks": "week",
	"form.recurring.weeks_plural": "{{count}} weeks",
	"form.recurring.months": "month",
	"form.recurring.months_plural": "{{count}} months",
	"form.recurring.years": "year",
	"form.recurring.years_plural": "{{count}} years",
	"form.recurringDeterminant.days.one": "every",
	"form.recurringDeterminant.days.other": "every",
	"form.recurringDeterminant.weeks.one": "every",
	"form.recurringDeterminant.weeks.other": "every",
	"form.recurringDeterminant.months.one": "every",
	"form.recurringDeterminant.months.other": "every",
	"form.recurringDeterminant.years.one": "every",
	"form.recurringDeterminant.years.other": "every",
	"form.recurring.summary":
		"This transaction will be repeated {{determinant}} {{intervalAndUnit}} starting from {{date}}",
	"form.recurring.manage": "Manage recurrences",

	// Recurring transactions page
	"recurring.title": "Recurring transactions",
	"recurring.loading": "Loading recurring transactions...",
	"recurring.active": "Active",
	"recurring.paused": "Paused",
	"recurring.next": "Next:",
	"recurring.pause": "Pause",
	"recurring.resume": "Resume",
	"recurring.pausing": "Pausing recurrence...",
	"recurring.resuming": "Resuming recurrence...",
	"recurring.delete": "Delete recurrence",
	"recurring.empty.title": "No recurring transaction",
	"recurring.empty.description":
		"You haven't set up any recurring transactions yet. Create one from the add transaction form.",
	"recurring.edit": "Edit recurrence",
	"recurring.upcoming.title": "Upcoming",
	"recurring.upcoming.seeAll": "See all",
	"recurring.upcoming.today": "Today",
	"recurring.upcoming.tomorrow": "Tomorrow",

	// 404 - Not Found page
	"404.title": "Page not found",
	"404.message": "Oops! Page not found.",
	"404.backHome": "Back to home",

	// Action buttons
	"action.edit": "Edit",
	"action.delete": "Delete",
	"action.deleting": "Deleting...",
	"action.back": "Back",
	"action.save": "Save",
	"action.saving": "Saving...",
	"action.confirm": "Confirm",
	"action.confirming": "Confirming...",
	"action.cancel": "Cancel",
	"action.resendVerification": "Resend verification email",

	// Alert and errors inside the app
	"alert.userNotLoggedIn": "User not logged in.",
	"alert.missingMandatoryFields": "Please fill in all mandatory fields!",
	// Transactions: add/fetch/edit/delete
	"alert.transactionAdded": "Transaction added successfully!",
	"alert.transactionError": "Error adding transaction.",
	"error.fetchTransactions": "Error fetching transactions.",
	"alert.futureDateRequired": "The next occurrence date must be in the future.",
	"alert.updateSuccess": "Transaction updated successfully.",
	"alert.recurringUpdateSuccess": "Recurrence updated successfully.",
	"alert.updateError": "Error updating transaction.",
	"alert.saveError": "Error saving. Please try again.",
	"alert.confirmDeleteEntry": "Do you really want to delete this transaction?",
	"alert.deleteSuccess": "Transaction deleted successfully.",
	"error.deleteTransaction": "Error deleting transaction.",
	"error.deleteRecurring": "Error deleting recurrence.",
	"alert.recurringPaused": "Recurrence paused.",
	"alert.recurringResumed": "Recurrence resumed.",
	"alert.confirmDeleteRecurring":
		"Do you really want to delete this recurrence? This will not affect transactions already created.",
	"alert.recurringDeleted": "Recurrence successfully deleted.",
	// Generic alerts and errors
	"alert.genericError": "An error occurred. Please try again.",
	"error.permissions": "You do not have permission to access this data.",
	"error.title": "An error occurred",
	"error.message": "Error:",
	"error.network": "No internet connection. Check your network and try again.",
	"error.userNotConnected": "User not connected",
	"error.retry": "Retry",
	// Settings alerts and errors
	"alert.emailNotVerified":
		"Please verify your email address to access the rest of the application.",
	"alert.verificationEmailSent": "A verification email has been sent.",
	"alert.verificationEmailError": "Failed to send verification email.",
	"alert.emailUpdateError": "Error updating email address.",
	"alert.invalidEmail": "Invalid email address.",
	"alert.emailInUse": "This email address is already in use.",
	"alert.exportSuccess": "Data export successful",
	"alert.exportFailed": "Data export failed",
	"alert.wrongPassword": "Incorrect password.",
	"alert.confirmDeleteAccount": "Do you really want to delete your account?",
	"alert.resetPasswordSent":
		"A reset password email has been sent to {{email}}.",
	"error.userNotLoggedIn": "User not logged in",
	"error.passwordRequired": "Password required",
	"error.reauthenticationFailed": "Re-authentication failed:",
	"alert.updatingEmail": "Updating email...",
	"alert.emailUpdatedSuccessfully": "Email address updated successfully!",
	"alert.emailAlreadyVerified": "Email is already verified",
	"alert.tooManyRequests":
		"Too many requests. Please wait before trying again.",
	"alert.userDocumentNotFound": "User document not found",
	"alert.reauthRequired": "Re-authentication required",
	"alert.operationNotAllowed":
		"Operation not allowed. Check Firebase configuration.",
	"alert.verificationInstructionsForUpdate":
		"Please verify your new email ({{email}}) by clicking on the link received by email to finalize the change.",
	"settings.pendingEmailPrefix": "New email awaiting verification:",
	"settings.pendingEmailInstructions":
		"Check your email inbox and click the verification link to finalize the change.",

	// Categories
	"category.food": "Food",
	"category.general": "General",
	"category.personal": "Personal",
	"category.health": "Health",
	"category.housing": "Housing",
	"category.savings": "Savings",
	"category.income": "Income",

	// Subcategories
	"subCategory.food.groceries": "Groceries",
	"subCategory.food.restaurant": "Restaurant",
	"subCategory.food.seazon": "Seazon",

	"subCategory.general.transport": "Transport",
	"subCategory.general.home": "Home",
	"subCategory.general.utilities": "Utilities",
	"subCategory.general.donations": "Donations",
	"subCategory.general.other": "Other",

	"subCategory.personal.vacation": "Vacation",
	"subCategory.personal.activities": "Activities",
	"subCategory.personal.shopping": "Shopping",
	"subCategory.personal.sport": "Sport",
	"subCategory.personal.subscriptions": "Subscriptions",
	"subCategory.personal.gifts": "Gifts",
	"subCategory.personal.other": "Other",

	"subCategory.health.doctor": "Doctor",
	"subCategory.health.pharmacy": "Pharmacy",
	"subCategory.health.cosmectics": "Cosmetics",
	"subCategory.health.other": "Other",

	"subCategory.housing.loan": "Loan/Rent",
	"subCategory.housing.charges": "Charges",
	"subCategory.housing.insurance": "Insurance",

	"subCategory.income.salary": "Salary",
	"subCategory.income.lunchTickets": "Lunch tickets",
	"subCategory.income.socialSecurityRefund": "Social security refund",
	"subCategory.income.healthInsuranceRefund": "Health insurance refund",
	"subCategory.income.other": "Other",

	// Terms and conditions page
	"terms.title": "Terms of Use",
	"terms.updated": "Last updated: July 24, 2025",

	"terms.sections.editor": "1. Publisher",
	"terms.sections.scope": "2. Purpose of the Application",
	"terms.sections.acceptance": "3. Acceptance of the Terms",
	"terms.sections.access": "4. Access to the Application",
	"terms.sections.data": "5. Personal Data",
	"terms.sections.intellectual": "6. Intellectual Property",
	"terms.sections.liability": "7. Liability",
	"terms.sections.deletion": "8. Account Deletion",
	"terms.sections.changes": "9. Changes to the Terms",
	"terms.sections.law": "10. Governing Law",

	"terms.content.editor":
		"<strong>Numerys</strong> is published by Paul BREARD, residing at 16 avenue George Pompidou, 92800 Puteaux, France. For any inquiries, you can contact us at: {{emailLink}}.",
	"terms.content.scope":
		"Numerys is a free web application that allows users to manually track their income and expenses. It also provides financial analysis in the form of statistics and visualizations. The application does not connect to bank accounts, but it does support automation of recurring transactions.",
	"terms.sections.acceptance":
		"By using the application, users fully accept these Terms of Use. By creating an account on Numerys, the user acknowledges having read and unconditionally accepted the Terms.",
	"terms.content.access":
		"The application is free and available to anyone with Internet access. Registration and account creation are required to access its features. There are no formal age or geographic restrictions, but the app is primarily designed for adult and teenage users.",
	"terms.content.data":
		"Using Numerys involves the collection of personal data (e.g., name, email, manual transactions, user preferences). This data is processed in accordance with the privacy policy available on the login, error, and settings pages. Users may access, update, export, or delete their personal data at any time via the account settings.",
	"terms.content.intellectual":
		"All elements of the Numerys application — including its name, logo, visual identity, design, texts, source code, and features — are protected by copyright law. Any reproduction, representation, modification, publication, or adaptation of any part of the application by any means is prohibited without the prior written consent of the publisher. Users retain ownership of their personal data and may freely export it in JSON format through the application interface.",
	"terms.content.liability":
		"The publisher makes all reasonable efforts to ensure quality access to the application, but shall not be held liable:",
	"terms.content.liability1":
		"In case of service interruption for maintenance or updates,",
	"terms.content.liability2":
		"In case of technical malfunction beyond its control,",
	"terms.content.liability3":
		"In case of errors, inaccuracies, or omissions in the automatically generated financial analyses.",
	"terms.content.liability.purpose":
		"The information provided by Numerys is for informational purposes only and does not constitute financial or tax advice.",
	"terms.content.deletion":
		"Users may delete their account at any time from their profile settings. Deletion results in the permanent loss of access to their data unless it has been exported beforehand.",
	"terms.content.changes":
		"The publisher reserves the right to modify these Terms at any time. Substantial changes will be notified through the application. Continued use of Numerys after any modification constitutes acceptance of the updated Terms.",
	"terms.content.law":
		"These Terms are governed by French law. In the event of a dispute, French courts shall have exclusive jurisdiction.",

	// Privacy Policy page
	"privacy.title": "Privacy Policy",
	"privacy.updated": "Last updated: July 2, 2025",

	"privacy.sections.who": "1. Who are we?",
	"privacy.content.who":
		"The Numerys app is a personal finance management tool, developed and maintained by Paul BREARD, who is responsible for data processing. For any questions related to privacy or the General Data Protection Regulation (GDPR), you can contact us at: {{emailLink}}.",

	"privacy.sections.data": "2. Personal data collected",
	"privacy.content.data":
		"We only collect the data necessary for using the app:",
	"privacy.content.data.auth":
		"Authentication data: email address, password (encrypted via Firebase Authentication).",
	"privacy.content.data.profile":
		"Profile data: user preferences (language, theme), role (user/admin).",
	"privacy.content.data.financial":
		"Financial data: transactions entered by the user (type, amount, category, date, etc.).",
	"privacy.content.data.technical":
		"Technical data: no technical data (IP address, logs, device ID, etc.) is voluntarily stored in the database.",

	"privacy.sections.hosting": "3. Data hosting",
	"privacy.content.hosting1":
		"User data is hosted on Google Firebase, in the europe-west1 region (Belgium/EU). Access is governed by the standard contractual clauses approved by the European Commission.",
	"privacy.content.hosting2":
		"The website itself is hosted on Vercel, a cloud platform based in the United States. Vercel may temporarily store certain technical information (IP address, request data, access logs) as part of its normal operations, but Numerys does not directly access or use this data.",

	"privacy.sections.security": "4. Data security",
	"privacy.content.security":
		"Access is protected by Firebase Authentication and strict Firestore security rules. Only the user can access their own data, unless granted an admin role. No personal or sensitive data is publicly accessible.",

	"privacy.sections.retention": "5. Data retention period",
	"privacy.content.retention":
		"Data is retained as long as the account is active. If the account is deleted, all personal data (transactions, preferences, etc.) is permanently and irreversibly deleted.",

	"privacy.sections.rights": "6. User rights",
	"privacy.content.rights":
		"In accordance with the GDPR, you have the following rights:",
	"privacy.content.rights.access": "Right to access your data.",
	"privacy.content.rights.update":
		"Right to update your information (email address, preferences).",
	"privacy.content.rights.delete":
		"Right to delete your account and all associated data.",
	"privacy.content.rights.export": "Right to export your data.",
	"privacy.content.rights.settings":
		"These rights can be exercised directly from your account Settings page, without needing to contact us.",

	"privacy.sections.cookies": "7. Use of cookies",
	"privacy.content.cookies":
		"The Numerys application does not use first-party cookies for tracking or advertising purposes. However, third-party technical cookies may be set by the following services:",
	"privacy.content.cookies.auth":
		"Firebase Authentication: used to securely manage user sessions.",
	"privacy.content.cookies.host":
		"Vercel (site host): Vercel may collect anonymous technical data (e.g., IP address, performance information, error logs) for analysis, security, and caching purposes. This data is neither accessed nor used by Numerys for any personal purpose.",
	"privacy.content.cookies.consent":
		"We do not set any non-essential cookies, which is why no consent banner is currently displayed. If this changes in the future (e.g., use of analytics or advertising cookies), this policy will be updated and a consent mechanism will be implemented.",

	"privacy.sections.updates": "8. Changes",
	"privacy.content.updates":
		"We reserve the right to update this privacy policy. Any changes will be displayed on this page with the update date.",
};

export default en;
